import { Trans, useTranslation } from "react-i18next";
import "./ConfirmDeleteModal.css";

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
}

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm, itemName }: ConfirmDeleteModalProps) => {
  const { t } = useTranslation(["company", "common"]);
  if (!isOpen) return null;

  const name = itemName ?? t("confirmDelete.defaultItemName");

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <div className="confirm-modal-icon">
            <i className="fa-solid fa-triangle-exclamation" />
          </div>
          <h2 className="confirm-modal-title">{t("confirmDelete.title")}</h2>
        </div>

        <p className="confirm-modal-message">
          <Trans t={t} i18nKey="confirmDelete.message" values={{ name }} components={{ strong: <strong /> }} />
        </p>

        <div className="confirm-modal-footer">
          <button type="button" className="confirm-modal-button confirm-modal-button--cancel" onClick={onClose}>
            {t("common:actions.cancel")}
          </button>
          <button type="button" className="confirm-modal-button confirm-modal-button--confirm" onClick={handleConfirm}>
            {t("common:actions.delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
